// Which area-intelligence layers have real data in the loaded H3 cells.
//
// The backend sends average_traffic_score / population_density as null when a
// cell has no data. Before that, missing values arrived as 0 — and the only
// values that ever existed were random ones from the test-data generator — so
// the map offered "Traffic Density" and "Population Density" layers that
// showed nothing true. A layer is offered only when some cell has a value.
export function availableAreaLayers(features) {
  const has = (key) => (features || []).some((f) => {
    const v = f?.properties?.[key];
    return v !== null && v !== undefined;
  });
  return {
    traffic: has('average_traffic_score'),
    population: has('population_density'),
  };
}

// The H3 view to show: the requested one, or 'sales' when it has no data.
export function effectiveH3View(view, layers) {
  if (view === 'traffic' && !layers.traffic) return 'sales';
  if (view === 'population' && !layers.population) return 'sales';
  return view;
}
